// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".user-profile-mfa-factor-button {\n    margin-top: 8px;\n}\n\n.user-profile-full-width {\n    width: 100%;\n}\n\n.user-profile-row {\n    text-align: center;\n}\n\n.user-profile-status {\n    margin-top: 16px;\n}", ""]);
// Exports
module.exports = exports;
